import { getAuthInstance } from '@fusion/auth-v3'
import { HTTPMethods, HTTPMode, useToken, ContentType } from './utils'

export type TypedResponse<T = unknown> = Omit<Response, 'json'> & {
  json(): Promise<T>
}

export const GET = async function <T = unknown>(
  route: string,
  optHeaders = {},
  optConfig = {},
  host: string = APP_ENV.VITE_APP_CLIENT_URL
) {
  const auth = getAuthInstance()
  const token = await auth.getTokenSilently()
  const headerConfig = {
    Authorization: useToken(token),
    Accept: ContentType.JSON
  }
  const fetchConfig = {
    method: HTTPMethods.GET,
    mode: HTTPMode.CORS,
    headers: new Headers({ ...headerConfig, ...optHeaders })
  }
  const response = await fetch(`${host}${route}`, {
    ...fetchConfig,
    ...optConfig
  })
  return response as TypedResponse<T>
}

export const GET_STREAM = async function <T = unknown>(
  route: string,
  optHeaders = {},
  optConfig = {},
  host = APP_ENV.VITE_APP_CLIENT_URL
) {
  const auth = getAuthInstance()
  const token = await auth.getTokenSilently()
  const headerConfig = {
    Authorization: useToken(token),
    Accept: ContentType.EVENT_STREAM
  }
  const fetchConfig = {
    method: HTTPMethods.GET,
    mode: HTTPMode.CORS,
    headers: new Headers({ ...headerConfig, ...optHeaders })
  }
  const response = await fetch(`${host}${route}`, {
    ...fetchConfig,
    ...optConfig
  })
  return response as TypedResponse<T>
}

export const POST = async function <T = unknown>(
  route: string,
  body: BodyInit | null,
  optHeaders = {},
  optConfig = {},
  host = APP_ENV.VITE_APP_CLIENT_URL
) {
  const auth = getAuthInstance()
  const token = await auth.getTokenSilently()
  const headerConfig = {
    Authorization: useToken(token),
    Accept: ContentType.JSON,
    'Content-Type': ContentType.JSON
  }
  const fetchConfig = {
    method: HTTPMethods.POST,
    mode: HTTPMode.CORS,
    headers: new Headers({ ...headerConfig, ...optHeaders }),
    body
  }
  const response = await fetch(`${host}${route}`, {
    ...fetchConfig,
    ...optConfig
  })
  return response as TypedResponse<T>
}

export const PATCH = async function <T = unknown>(
  route: string,
  body: BodyInit | null,
  optHeaders = {},
  optConfig = {},
  host = APP_ENV.VITE_APP_CLIENT_URL
) {
  const auth = getAuthInstance()
  const token = await auth.getTokenSilently()
  const headerConfig = {
    Authorization: useToken(token),
    Accept: ContentType.JSON,
    'Content-Type': ContentType.JSON
  }
  const fetchConfig = {
    method: HTTPMethods.PATCH,
    mode: HTTPMode.CORS,
    headers: new Headers({ ...headerConfig, ...optHeaders }),
    body
  }
  const response = await fetch(`${host}${route}`, {
    ...fetchConfig,
    ...optConfig
  })
  return response as TypedResponse<T>
}

export const DELETE = async function <T = unknown>(
  route: string,
  optHeaders = {},
  optConfig = {},
  host = APP_ENV.VITE_APP_CLIENT_URL
) {
  const auth = getAuthInstance()
  const token = await auth.getTokenSilently()
  const headerConfig = {
    Authorization: useToken(token),
    Accept: ContentType.JSON
  }
  const fetchConfig = {
    method: HTTPMethods.DELETE,
    mode: HTTPMode.CORS,
    headers: new Headers({ ...headerConfig, ...optHeaders })
  }
  const response = await fetch(`${host}${route}`, {
    ...fetchConfig,
    ...optConfig
  })
  return response as TypedResponse<T>
}
